import { useQuery } from '@tanstack/react-query'
import { admin } from '../../api'
import { formatBytes, formatDate } from '../../format'

const ACTION_LABELS: Record<string, string> = {
  login: '로그인',
  upload: '업로드',
  download: '다운로드',
  delete: '삭제',
  mkdir: '폴더 생성',
  rename: '이름 변경',
  'password.change': '비밀번호 변경',
  'admin.user.create': '계정 추가',
  'admin.user.update': '계정 수정',
  'admin.user.delete': '계정 삭제',
  'admin.node.create': '노드 추가',
  'admin.node.update': '노드 수정',
  'admin.node.delete': '노드 삭제',
  'admin.node.rotate_token': '토큰 재발급',
  'admin.share.create': '공유 추가',
  'admin.share.update': '공유 수정',
  'admin.share.delete': '공유 삭제',
}

export default function AdminAudit() {
  const entries = useQuery({
    queryKey: ['admin', 'audit'],
    queryFn: admin.audit,
    refetchInterval: 20_000,
  })

  return (
    <section>
      <table className="entries">
        <thead>
          <tr>
            <th className="num">시각</th>
            <th>사용자</th>
            <th>동작</th>
            <th>경로</th>
            <th className="num">크기</th>
          </tr>
        </thead>
        <tbody>
          {entries.data?.length === 0 && (
            <tr>
              <td colSpan={5} className="muted center">
                기록이 없습니다.
              </td>
            </tr>
          )}
          {entries.data?.map((entry) => (
            <tr key={entry.id} className={entry.succeeded ? '' : 'failed'}>
              <td className="num small">{formatDate(entry.at)}</td>
              <td className="mono small">{entry.actor ?? '-'}</td>
              <td>
                {ACTION_LABELS[entry.action] ?? entry.action}
                {!entry.succeeded && <span className="error small"> 실패</span>}
              </td>
              <td className="mono small" title={entry.detail}>
                {entry.path || entry.detail || '-'}
              </td>
              <td className="num">{entry.bytes === null ? '-' : formatBytes(entry.bytes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
